import { NotificationManager } from 'react-notifications'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import React, { Fragment, useState, useEffect } from 'react'
import { ReactComponent as LogoCog } from '../../../assets/images/LogoComponents/ios-cog.svg'
import DataForm from './DataForm'
import PageTitleAlt from '../../../Layout/AppMain/PageTitleAlt'
import { Button, Modal, ModalBody } from 'reactstrap'
import querystring from 'querystring'

const FlatOwnerProfile = ({ history, location }) => {
  let qs = location.search.replace('?', '')
  const { isFirst } = querystring.parse(qs)
  const { t, i18n } = useTranslation()
  const [passwords, setPasswords] = useState({
    current_password: '',
    new_password: '',
    new_password_confirmation: ''
  })
  const [user, setUser] = useState({})
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const onHandleFormSubmit = async event => {
    event.preventDefault()

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/password/change-password`,
        { ...passwords },
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('authToken'),
            'Content-Language': i18n.language === 'cz' ? 'cs' : 'en'
          }
        }
      )
      NotificationManager.success(t('common.success'))
    } catch (error) {}
  }

  useEffect(() => {
    if (isFirst) {
      setOpen(true)
    }
    const fetchData = async () => {
      setLoading(true)
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/v1/users/profile`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('authToken'),
              'Content-Language': i18n.language === 'cz' ? 'cs' : 'en'
            }
          }
        )
        const userData = response.data.data
        setUser(userData)
        setLoading(false)
      } catch (error) {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  const onHandleChangePasswords = e => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value })
  }

  const handleModalClick = () => {
    setOpen(false)
    history.replace('/profile')
  }

  return (
    <Fragment>
      <Modal
        size='md'
        style={{ boxShadow: 'none' }}
        isOpen={open}
        centered
        toggle={() => setOpen(false)}>
        <ModalBody className='p-4'>
          {t('common.resetPasswordNotification')}
          <Button
            className='w-100 mt-3'
            color='primary'
            onClick={handleModalClick}>
            {t('common.iUnderstand')}
          </Button>
        </ModalBody>
      </Modal>
      <PageTitleAlt
        heading={t('pageTitles.settings')}
        icon={<LogoCog className='SVGLogo' style={{ fill: '#343a40' }} />}
      />
      <DataForm
        loading={loading}
        user={user}
        passwords={passwords}
        onHandleChangePasswords={onHandleChangePasswords}
        onHandleFormSubmit={onHandleFormSubmit}
      />
    </Fragment>
  )
}

export default FlatOwnerProfile
